import * as React from 'react';
import { getRouteInfo } from '../../utils/route';
import { ROUTE_ICONS_BY_TYPE } from './constants';
import * as styles from './MapRouteInfo.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MapRouteInfoComponent = function MapRouteInfoComponent(_ref) {
  var route = _ref.route;
  var Icon = ROUTE_ICONS_BY_TYPE.get(route.type);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [Icon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: Icon
    }), /*#__PURE__*/_jsx("span", {
      className: styles['label'],
      children: getRouteInfo(route)
    })]
  });
};
export var MapRouteInfo = /*#__PURE__*/React.memo(MapRouteInfoComponent);